import type { Comp, GameObj, OpacityComp, PosComp, ScaleComp } from "kaplay";
import { PX_PER_M } from "../config/constants";
import { k } from "../core/kaplay";
import { heightAboveGround } from "../systems/air";
import type { Rider } from "./rider";

const OPACITY = 0.35;
const SHRINK_PER_M = 0.12;
const MIN_SCALE = 0.4;

export function shadowOf(rider: Rider): Comp {
    return {
        id: "shadowOf",
        require: ["pos", "opacity", "scale"],
        update(this: GameObj<PosComp | OpacityComp | ScaleComp>) {
            if (!rider.exists()) return this.destroy();
            const height = heightAboveGround(rider.air);
            const belowLip = height - Math.max(0, rider.air.height);
            this.pos = rider.pos.add(0, belowLip * PX_PER_M);
            this.opacity = rider.isAirborne() ? OPACITY : 0;
            this.scale = k.vec2(Math.max(MIN_SCALE, 1 - height * SHRINK_PER_M));
        },
    };
}
